import { map, prop } from 'ramda';

import { compact } from '../../../helpers/compact';
import { DocumentType } from '../../../types/document';
import { FILTER, MENU } from '../../../types/filters';
import { toImageFromProp } from '../fields/image';
import { toRichTextFromProp, toTextFromProp } from '../fields/text';
import { deprecatedPageEntity } from './internal';

const createSection = ({ primary, items }) => {
  return {
    illustration: toTextFromProp('illustration', primary),
    title: toTextFromProp('next_title', primary),
    description: toRichTextFromProp('next_description', primary),
    popup: {
      subtitle: toRichTextFromProp('next_popup_subtitle', primary),
      content: map(
        (elt) => ({
          image: toImageFromProp('next_popup_image', elt),
          link: prop('next_popup_link', elt),
        }),
        items
      ),
    },
  };
};

/**
 * Transform the given input into objects
 *
 * @param  {PrismicOurBrands} data
 * @return {OurBrandsSchema}
 */
const processOurBrands = (data) => {
  return compact({
    uid: DocumentType.OUR_BRANDS,
    type: DocumentType.OUR_BRANDS,
    firstpage: {
      title: toTextFromProp('title', data),
      description: toRichTextFromProp('description', data),
    },
    nextpage: map(createSection, prop('slices', data)),
    filters: {
      [FILTER.MENU]: MENU.ACTIVITY,
    },
  });
};

/**
 * Normalizr schema representing a our brands page
 */
export const OurBrands = deprecatedPageEntity(DocumentType.OUR_BRANDS, {
  processStrategy: (entity) => ({
    ...processOurBrands(prop('data', entity)),
  }),
});
